import React from 'react';
import { Image } from './IconImage.model';
import { getIcon } from './IconImage.service';
import { StyledImage } from './IconImage.styled';
export interface UHCIconImageProps {
    image?: Image;
    color: boolean;
    size?: number
    showIconSo?: boolean
    shortname?: Image['operationalSystem']['shortName']
}

const UHCIconImage: React.FC<UHCIconImageProps> = ({ image, color, size = 31, showIconSo, shortname }: UHCIconImageProps): JSX.Element => {

    const imageUrl = getIcon(image, color, showIconSo, shortname)

    return (
        <>
            <StyledImage data-testid="imageIcon" src={imageUrl} size={size} />
        </>
    );
};

export default UHCIconImage;
